import "./style.scss";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy-section">
      <div className="container privacy-policy-head">
        <div className="row">
          <div className="col-12">
            <h2>Privacy Policy for <br/>Non-Employees</h2>
          </div>
        </div>
      </div>
      <div className="container privacy-policy-content">
        <div className="row">
          <div className="col-12">
            <p>
              <b>Last Updated:</b> 07 Aug 2025
            </p>
            <p>
              This Privacy Notice for Non‑Employees (“Notice”) applies to
              non‑employees of Fractile Studio, including contractors, vendors,
              suppliers, applicants, visitors, and others who are not past,
              present, or potential employees of our company (“We”, “Us”, or
              “Our”). This Notice does not apply to employees, former employees,
              or job applicants. For employee‑related privacy, please refer to
              our separate Past, Present & Potential Employees Privacy Notice.
            </p>
            <p>
              We respect your privacy. This Notice describes the categories of
              personal information we may collect from you—including information
              you provide when visiting our website or interacting with us—and
              explains how we collect, use, maintain, protect, and disclose that
              information
            </p>

            <h4>Children Under the Age of 16</h4>
            <p>
              Our Website is not intended for children under 16 years of age. No
              one under the age of 16 may provide any information to the
              Website. We do not knowingly collect personal information from
              children under the age of 16. If you believe we might have any
              information from or about a child under the age of 16, please fill
              out this form or mail us at Contact@fractilestud.io{" "}
            </p>

            <h4>
              Information We Collect
            </h4>
            <p>
              We collect information that identifies, relates to, describes,
              references, is reasonably capable of being associated with, or
              could reasonably be linked, directly or indirectly, with a
              particular consumer, household, or device ("personal
              information").
            </p>
            <p>
              <b>Personal information does not include:</b>
            </p>
            <ul>
              <li>Publicly available information from government records.</li>
              <li>Deidentified or aggregated consumer information.</li>
            </ul>
            <p>
              <b>
                In particular, we have collected the following categories of
                personal information from consumers within the last twelve (12)
                months:
              </b>
            </p>
            <ul>
              <li>
                <b>Identifiers:</b> Such as a real name, alias, postal address, unique personal identifier, online identifier, IP address, email address.
              </li>
              <li>
                <b>California Customer Records:</b> Name, signature, address, telephone number, etc.
              </li>
              <li>
                <b>Protected classification characteristics:</b> Age, race, religion, disability, sex, veteran or military
                status.
              </li>
              <li>
                <b>Commercial information:</b> Purchasing history or tendencies.
              </li>
              <li>
                <b>Biometric information:</b> Physiological, behavioral, and biological characteristics.
              </li>
              <li>
                <b>Internet or other network activity:</b> Browsing history, interactions with website or advertisements.
              </li>
              <li>
                <b>Sensory data:</b> Audio, electronic, visual, thermal, olfactory, or similar
                information.
              </li>
            </ul>
            <h4>
              Sources of Personal Information
            </h4>
            <p>
              We obtain the categories of personal information listed above from
              the following categories of sources:
            </p>
            <ul>
              <li>Directly from you.</li>
              <li>Indirectly from you.</li>
              <li>Automatically as you navigate through the Website.</li>
              <li>From third party vendors.</li>
            </ul>
            <h4>
              Automatic Data Collection
            </h4>
            <p>
              As you navigate through and interact with our Website, we may use
              automatic data collection technologies to collect information
              about your device, browsing actions, and patterns.
            </p>
            <ul>
              <li>
                <b>Cookies:</b> A small file placed on your computer’s hard
                drive.
              </li>
              <li>
                <b>Web Beacons:</b> Small electronic files used to count users or verify server
                integrity.
              </li>
            </ul>
            <p>
              Some browsers have “Do Not Track” features, but we do not
              currently respond to those signals. Blocking cookies may impair
              some features.
            </p>
            <h4>
              Use of Personal Information
            </h4>
            <p>
              We may use or disclose the personal information we collect for
              business purposes such as:
            </p>
            <ul>
              <li>Sharing with our related companies.</li>
              <li>Marketing purposes.</li>
              <li>Providing support and responding to inquiries.</li>
              <li>Maintaining safety and security.</li>
              <li>Testing and development.</li>
              <li>Legal compliance and investigations.</li>
            </ul>
            <h4>
              Sharing Personal Information
            </h4>
            <p>
              We do not sell your personal information. We may disclose it to:
            </p>
            <ul>
              <li>Service providers.</li>
              <li>Governmental or regulatory authorities.</li>
              <li>Third parties at your direction.</li>
            </ul>
            <h4>
              California Privacy Notice
            </h4>
            <p>
              This section applies to California residents and complies with the
              California Consumer Privacy Act (CCPA) and California Privacy
              Rights Act (CPRA).
            </p>
            <p>
              We may collect and share categories as described in “Information
              We Collect” and “Sharing Personal Information.”
            </p>
            <p>
              <b>Your Rights under CCPA include:</b>
            </p>
            <ul>
              <li>Right to access and data portability.</li>
              <li>Right to request deletion of your personal information.</li>
              <li>Right to correction of inaccurate information.</li>
              <li>Right to opt-out of sale or sharing of personal data.</li>
              <li>Right to non-discrimination for exercising your rights.</li>
            </ul>
            <h4>
              Exercising Your Rights
            </h4>
            <p>You can submit requests by:</p>
            <ul>
              <li>
                Calling us at: <a href="tel:(571) 297-1409">(571) 297-1409</a>
              </li>
              <li>
                Contacting us via our mail Contact@fractilestud.io
                
              </li>
            </ul>
            <h4>
              Response Timing and Fees
            </h4>
            <p>
              We aim to respond within 45 days. No fees unless requests are
              excessive, repetitive, or unfounded.
            </p>
            <h4>
              Other State Privacy Rights
            </h4>
            <p>
              Residents of other states may have rights to access, delete,
              correct, or receive their personal information and opt out of
              certain data uses.
            </p>
            <h4>
              Changes to Our Privacy Notice
            </h4>
            <p>
              We may update this Notice at any time. Continued use of the site
              after updates means acceptance of the new terms.
            </p>
            <h4>
              Contact Information
            </h4>
            <p>
              For any questions or to exercise your privacy rights, contact us:
            </p>
            <p>
              <b>Phone:</b>
              <a href="tel:(571) 297-1409">(571) 297-1409</a>
            </p>
            <p>
              <b>Website:</b>
              <a href="/privacy-policy">
                Fractile Studio Contact Page
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
